import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./style";
import { setSelectedClient, setCalendarEntries } from "../../../../store/reducers/mar";
import { ActionIcon, Box, Loader, TextInput, Tooltip } from "@mantine/core";
import { FiSearch, FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

const UserDetail = ({ isClient, setLocalSelectedClient = () => {} }) => {
  const { classes } = useStyles();

  const { allPatients, loading } = useSelector((state) => state?.patient);
  const { selectedClient } = useSelector((state) => state?.mar);

  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [collapsed, setCollapsed] = useState(false);

  const activePatients = allPatients?.filter(
    (_p) => _p?.active === true && _p?.deleted === false,
  );

  const filteredPatients = search.trim()
    ? activePatients?.filter((_p) =>
        _p?.name?.toLowerCase().includes(search.trim().toLowerCase()),
      )
    : activePatients;

  const handleSelect = (obj) => {
    dispatch(setCalendarEntries([]));
    dispatch(setSelectedClient(obj));
    localStorage.setItem("selectedClient", JSON.stringify(obj));
    setLocalSelectedClient(obj);
  };

  return (
    <div className={classes.clientPanelWrapper}>
      {collapsed ? (
        <div className={classes.clientPanelCollapsed}>
          <Tooltip label="Expand client panel" position="right" withArrow>
            <ActionIcon
              variant="default"
              size="sm"
              onClick={() => setCollapsed(false)}
              className={classes.collapseToggleBtn}
            >
              <FiChevronsRight size={16} />
            </ActionIcon>
          </Tooltip>
          <p className={classes.clientPanelCollapsedLabel}>Clients</p>
        </div>
      ) : (
        <div className={classes.scheduleDetailLeft}>
          <div className={classes.clientPanelHeader}>
            <p className={classes.clientPanelTitle}>Clients</p>
            <Tooltip label="Collapse client panel" position="right" withArrow>
              <ActionIcon
                variant="default"
                size="sm"
                onClick={() => setCollapsed(true)}
                className={classes.collapseToggleBtn}
              >
                <FiChevronsLeft size={16} />
              </ActionIcon>
            </Tooltip>
          </div>
          {loading ? (
            <Box className={classes.loadingBox}>
              <Loader color="yellow" size={"md"} />
            </Box>
          ) : (
            <>
              <TextInput
                placeholder="Search Client name"
                className={classes.inputStyle}
                icon={<FiSearch />}
                value={search}
                onChange={(e) => setSearch(e.currentTarget.value)}
              />
              {isClient ? (
                <div className={`${classes.list} listScroll`}>
                  <div
                    className={`${classes.item} ${classes.itemBg} ${
                      selectedClient?.id ? classes.itemActive : ""
                    }`}
                    onClick={() => handleSelect(selectedClient)}
                  >
                    <p>{selectedClient?.name}</p>
                  </div>
                </div>
              ) : (
                <div className={`${classes.list} listScroll`}>
                  {filteredPatients?.length > 0 &&
                    filteredPatients?.map((v, i) => (
                      <div
                        key={i}
                        className={`${classes.item} ${
                          selectedClient?.id === v?.id ? classes.itemActive : ""
                        }`}
                        onClick={() => handleSelect(v)}
                      >
                        <p>{v?.name}</p>
                      </div>
                    ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default UserDetail;
